module.exports = __webpack_public_path__ + "img/organization.4f5ad295.png";